import { MinusCircleOutlined, PlusCircleOutlined } from "@ant-design/icons";
import { Button, Form, Input, Space } from "antd";
import React from "react";

interface MethodListProps {
  name: string | number | (string | number)[];
}

export const MethodList = (props: MethodListProps) => {
  return (
    <Form.List name={props.name}>
      {(fields, { add, remove }) => (
        <Space direction="vertical">
          {fields.map((field) => (
            <Space key={field.key} direction="horizontal" align="baseline">
              <Form.Item
                {...field}
                validateTrigger={["onChange", "onBlur"]}
                name={[field.name, "name"]}
                rules={[
                  {
                    required: true,
                    whitespace: true,
                    message: "Please input method or delete this field.",
                  },
                ]}
                noStyle
              >
                <Input placeholder="Method name" />
              </Form.Item>
              <MinusCircleOutlined
                
                onClick={() => remove(field.name)}
              />
            </Space>
          ))}
          <Form.Item>
            <Button
              type="dashed"
              onClick={() => add({ name: "" })}
              icon={<PlusCircleOutlined  />}
            >
              Add Method
            </Button>
          </Form.Item>
        </Space>
      )}
    </Form.List>
  );
};
